import React from 'react'
import { Trans } from 'react-i18next'
import Dialog from '~/Common-Objects/UI/Dialog'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons'
import i18n from '~/i18n'
import { useSelector } from 'react-redux'

export default function NewEditorSwitcher({ onSwitchConfirm = () => {} }) {
    const siteMaster = useSelector((state) => state.siteMaster)
    const [showConfirm, setShowConfirm] = React.useState(false)
    return (
        <>
            <Button
                onClick={() => setShowConfirm(true)}
                iconLeft={<Icons icon='beaker' />}
                className='button-sml button-upsell'
            >
                <span>{i18n.t('templates:add.drag.try-new-editor')}</span>
            </Button>
            {showConfirm && (
                <ConfirmDialog
                    siteMaster={siteMaster}
                    onConfirm={onSwitchConfirm}
                    onCancel={() => setShowConfirm(false)}
                />
            )}
        </>
    )
}

const ConfirmDialog = ({ onConfirm = () => {}, onCancel = () => {}, siteMaster = {} }) => {
    let mainTextTranslation = i18n.t('templates:add.drag.new-editor-confirmation-modal.paragraphTwo')
    mainTextTranslation = mainTextTranslation.replace(
        /\[SUPPORTEMAIL\]/g,
        `<a href="mailto:${siteMaster.supportEmail}">${siteMaster.supportEmail}</a>`
    )
    return (
        <Dialog.Root open={true}>
            <Dialog.Portal>
                <Dialog.Overlay />
                <Dialog.Content>
                    <div style={{ padding: '24px' }}>
                        <h4 className='mar-b10'>{i18n.t('templates:add.drag.new-editor-confirmation-modal.header')}</h4>
                        <p>{i18n.t('templates:add.drag.new-editor-confirmation-modal.paragraphOne')}</p>
                        <p dangerouslySetInnerHTML={{ __html: mainTextTranslation }} />
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                <Button
                                    className='button-primary mar-r10'
                                    onClick={() => {
                                        onConfirm()
                                    }}
                                    postHogTag='dragdrop-open-new-editor'
                                >
                                    {i18n.t('templates:add.drag.new-editor-confirmation-modal.enable')}
                                </Button>
                                <Button
                                    text={i18n.t('templates:add.drag.new-editor-confirmation-modal.cancel')}
                                    onClick={() => {
                                        onCancel()
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    )
}
